import Navigation from "../navigation";
import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import WebsiteHeader from "fotor-website-header/websiteHeaderNoCss.bundle";
import { autoShowOpenAppConfirm, setCookie } from "@/utils";
import { HEADER_RESIDENT_ID, I18nLangMap, NAV_POSITION, PROJECT_TYPE, SCENE_ID } from "@/constants";
import { useCommonStore, useUserStore } from "@/stores";
import { useIsMobile } from "@/hooks";
import { useTranslation } from "react-i18next";
import EventHub from "@/utils/event";
import { GlobalEvent } from "@/constants/event";
import PcHeaderComponent from "../nav-download";
interface HeaderProps {
  mobileContent?: React.ReactNode;
  className?: string;
  onLogin?: () => void;
}
export default function Header(props: HeaderProps) {
  const { mobileContent, className } = props;
  const headerCompRef = useRef<any>();
  const { i18n } = useTranslation();
  const logoutCallback = useCommonStore((state) => state.logoutCallback);
  const resetUserStore = useUserStore((state) => state.reset);
  const setCredits = useUserStore((state) => state.setCredits);
  const isMobile = useIsMobile();

  // // 点击右上角的头像同步更新头里的积分
  // useEffect(() => {
  //   const el = document.querySelector(".login-header");
  //   if (el) {
  //     el.addEventListener("click", () => {
  //       useUserStore.getState().fetchCredits();
  //     });
  //   }
  //   return () => {
  //     if (el) {
  //       el.removeEventListener("click", () => {
  //         useUserStore.getState().fetchCredits();
  //       });
  //     }
  //   };
  // }, []);

  useEffect(() => {
    const remover = EventHub.getInstance().on(
      GlobalEvent.REFRESH_CREDITS,
      () => {
        // 同步更新头部积分
        const credits = useUserStore.getState().credits;
        headerCompRef.current?.updateCredits(credits);
      }
    );
    return () => {
      remover();
    };
  }, []);
  const headerCallback = (data: any) => {
    let { type } = data;

    if (type === "logout") {
      logoutCallback();
      resetUserStore();
      useUserStore.getState().fetchAllRemainNums();
    } else if (type === "rendered") {
    } else if (type === "login") {
      props.onLogin?.();
      if ([0, 1, 2, 3, 5, 6].includes(data.res.code)) {
        useUserStore.getState().initUserInfo(data.res.userInfo.data);
      }
      if (data.res.code === 4) {
        // 取消了登录，让他去app//自动拉起[open app]弹窗
        // autoShowOpenAppConfirm();
      }
    } else if (type === "language") {
      const localeKey = data.value || "en_US";
      const i18nKey = Object.keys(I18nLangMap).find(
        (key) => I18nLangMap[key] === localeKey
      );
      if (!["id"].includes(i18nKey!)) {
        setCookie("locale", localeKey);
      }
      i18n.changeLanguage(i18nKey);
    }
  };

  const handleChangeCredits = (credits: number) => {
    setCredits(credits);
    headerCompRef.current?.updateCredits(credits);
  };

  return (
    <WebsiteHeader
      ref={headerCompRef}
      style={{
        background: "#FFFFFF",
        boxShadow: "0px 1px 0px 0px rgba(0, 0, 0, 0.1)",
        position: "static",
      }}
      displayLanguageMenu={[
        "en",
        "es",
        "pt",
        "ru",
        "fr",
        "de",
        "cn",
        "tw",
        "jp",
        "id",
        "it",
        "th",
        "vi",
        "tr",
        "pl",
        "nl",
        "ko",
      ]}
      adLocation={HEADER_RESIDENT_ID}
      showOpenInApp={false}
      projectType={PROJECT_TYPE}
      noNavMenu={false}
      lang={I18nLangMap[i18n.language]}
      callback={headerCallback}
      noLanguage={true}
      ShowUpgradeButton={false}
      theme="white"
      env={process.env.REACT_APP_ENVIRONMENT}
      loginSensorsData={[
        { position: NAV_POSITION },
        true,
        { scenesId: SCENE_ID },
      ]}
      signUpSensorData={[
        { position: NAV_POSITION },
        true,
        { scenesId: SCENE_ID },
      ]}
      showCredits={{
        sensorsData: {

          project_type: PROJECT_TYPE,
          position: "swap_upgrade",
        },
      }}
      pageType="tool"
      onChangeCredits={handleChangeCredits}
      className={className}
    >
      {/* {!isMobile && <Navigation></Navigation>} */}
      {!isMobile && <PcHeaderComponent />}
      {isMobile && mobileContent}
    </WebsiteHeader>
  );
}
